import { IonCardContent, IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
import { useState } from 'react';

import { NameField, VarusValgusField } from '@/pages/ReportV2/components/Fields/Fields';

import { CardHeader } from '@/components/CardHeader/cardHeader';
import styles from '@/components/Cards/AttractorCard.module.css';
import { ReportModal } from '@/components/Modal/ReportModal';

import { mergeClassNames } from '@/utils/mergeClassNames';

import { Card } from '.';

type AttractorCardProps = {
  title: string;
  subtitle?: string;
  info: React.ReactNode;
  img: string;
  labels?: string[];
  attractorRow: number[];
  kpiLabels?: string[];
  varusValgus?: string[];
};

/** Card in the analysis page to show the avatar and attractor field
 * @param img - The avatar image
 * @param labels - Attractor labels for the status field, tuple of (Left, Right) values
 */
export const AttractorCard = ({
  title,
  subtitle,
  info,
  img,
  labels,
  kpiLabels,
  attractorRow,
  varusValgus,
}: AttractorCardProps) => {
  const kpiLabel = (labels: string[], kpi: number) => {
    const label = Number.isInteger(kpi) ? labels[kpi - 1] : labels[Math.round(kpi) - 1];
    return label;
  };
  const [showModal, setShowModal] = useState({
    show: false,
  });

  return (
    <>
      <ReportModal
        header={subtitle ? `${title} - ${subtitle}` : title}
        isOpen={showModal.show}
        onDidDismiss={() => setShowModal({ show: false })}
        setShowInfo={() => setShowModal({ show: false })}>
        {info}
      </ReportModal>

      <Card style={{ height: 'fit-content', margin: 0 }}>
        <CardHeader info={true} setShowInfo={setShowModal} subtitle={subtitle} title={title} />

        <IonCardContent className={styles.full_height}>
          <IonGrid class='ion-no-padding' fixed>
            <IonRow className={mergeClassNames(styles.full_width, 'ion-justify-content-center')}>
              <IonCol>
                <IonImg class={styles.avatar} src={img} />
              </IonCol>
            </IonRow>
            {labels && (
              <IonRow className={mergeClassNames(styles.full_width, 'ion-justify-content-center')}>
                <IonCol style={{ marginRight: '4px' }}>
                  <NameField name='Left' status={attractorRow[0]} value={labels[0]} />
                </IonCol>
                <span style={{ width: '1px', backgroundColor: '#e0e0e0' }} />
                <IonCol style={{ marginLeft: '4px' }}>
                  <NameField name='Right' status={attractorRow[1]} value={labels[1]} />
                </IonCol>
              </IonRow>
            )}
            {kpiLabels && !varusValgus && (
              <IonRow className={mergeClassNames(styles.full_width, 'ion-justify-content-center')}>
                <IonCol style={{ marginRight: '4px' }}>
                  <NameField name='Left' status={attractorRow[0]} value={kpiLabel(kpiLabels, attractorRow[0])} />
                </IonCol>
                <span style={{ width: '1px', backgroundColor: '#e0e0e0' }} />
                <IonCol style={{ marginLeft: '4px' }}>
                  <NameField name='Right' status={attractorRow[1]} value={kpiLabel(kpiLabels, attractorRow[1])} />
                </IonCol>
              </IonRow>
            )}
            {varusValgus && kpiLabels && (
              <IonRow className={mergeClassNames(styles.full_width, 'ion-justify-content-center')}>
                <IonCol style={{ marginRight: '4px' }}>
                  <VarusValgusField
                    label={varusValgus[0]}
                    name='Left'
                    status={attractorRow[0]}
                    value={kpiLabel(kpiLabels, attractorRow[0])}
                  />
                </IonCol>
                <span style={{ width: '1px', backgroundColor: '#e0e0e0' }} />
                <IonCol style={{ marginLeft: '4px' }}>
                  <VarusValgusField
                    label={varusValgus[1]}
                    name='Right'
                    status={attractorRow[1]}
                    value={kpiLabel(kpiLabels, attractorRow[1])}
                  />
                </IonCol>
              </IonRow>
            )}
          </IonGrid>
        </IonCardContent>
      </Card>
    </>
  );
};
